import { Component, EventEmitter, isDevMode, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { EnviaService } from '../../service/envia.service';

@Component({
  selector: 'app-form-shipping-user',
  imports: [ReactiveFormsModule],
  templateUrl: './form-shipping-user.component.html',
  styleUrl: './form-shipping-user.component.scss',
  standalone: true
})
export class FormShippingUserComponent implements OnInit {
  @Output() form = new EventEmitter<any>();

  formUser: FormGroup;
  listCountries: any = [];
  listStates: any = [];
  enableColonia = false;

  constructor(
    private fb: FormBuilder,
    private enviaServices: EnviaService,
  ) {



    this.enviaServices.getCountries().subscribe((res) => {
      this.listCountries = res.data;
    });
  }

  ngOnInit(): void {
    if (isDevMode()) {
      this.formUser = this.fb.group({
        first_name: ['Ricardo', [Validators.required]],
        last_name: ['Moisen', [Validators.required]],
        email: ['rikimm88@gmail.com', [Validators.required, Validators.email]],
        street: ['emiliano zapata', [Validators.required]],
        number: ['174', [Validators.required]],
        postalCode: ['15290', [Validators.required]],
        phone: ['5555012528', [Validators.required]],
        district: ['10 de mayo'],
        country: ['', [Validators.required]],
        state: ['', [Validators.required]],
        city: ['CDMX', [Validators.required]],
      });
    } else {
      this.formUser = this.fb.group({
        first_name: ['', [Validators.required]],
        last_name: ['', [Validators.required]],
        email: ['', [Validators.required, Validators.email]],
        street: ['', [Validators.required]],
        number: ['', [Validators.required]],
        postalCode: ['', [Validators.required]],
        phone: ['', [Validators.required]],
        district: [''],
        country: ['', [Validators.required]],
        state: ['', [Validators.required]],
        city: ['', [Validators.required]],
      });
    }

  }

  selectCountry(pais: any) {
    
    if (pais.value === 'MX') {
      this.enableColonia = true;
    } else {
      this.enableColonia = false;
    }
    this.enviaServices.getStates(pais.value).subscribe((res) => {
      this.listStates = res.data;
    });
  }
  calculateShipping() {
    if (this.formUser.invalid) {
      this.formUser.markAllAsTouched();
      return false;
    }
    
    const obj = {
      origin: {
        name: 'EToy Republic',
        company: 'etoyrepublic',
        email: 'contact@etoyrepublic.shop',
        phone: '5555012528',
        street: 'Emiliano Zapata',
        number: '174',
        district: 'other',
        city: 'CDMX',
        state: 'CMX',
        country: 'MX',
        postalCode: '15290',
        reference: '',
      },
      destination: this.formUser.value,
      packages: [
        {
          content: 'Art Toys',
          amount: 1,
          type: 'box',
          weight: 2,
          insurance: 0,
          declaredValue: 0,
          weightUnit: 'KG',
          lengthUnit: 'CM',
          dimensions: {
            length: 27,
            width: 27,
            height: 15,
          },
        },
      ],
      shipment: {
        carrier: 'fedex',
        type: 1,
      },
      settings: {
        currency: 'MXN',
      },
    };

    Object.assign(obj.destination, { name: `${this.formUser.value.first_name} ${this.formUser.value.last_name} ` });

    this.form.emit(obj);
    return true;
  }
}
